module.exports = __webpack_public_path__ + "static/media/sell_start_service_make_2.bd09bf55.jpg";